import axios from '../service/self_axios'
if(window.wx){
	axios.http.post('/wealth/js_api_signature',{
		url:location.href
	}).then(res => {
		// console.log('wx',res.data.signature)
		window.wx.config({
			// debug:true,
			appId:'wx4bc859e5fdbca1c1',
			timestamp: res.data.timestamp,
			nonceStr: res.data.noncestr,
			signature: res.data.signature,
			jsApiList:[
				"updateAppMessageShareData", //分享给好友
        "updateTimelineShareData" //分享到朋友圈
			]
		})
	}).catch(err => {
		console.log(err)
	})
}
